import { state, type Lang } from './state';

type Dict = Record<string, string>;

const it: Dict = {
  brandSub: 'Reazioni vincolari',
  bLoad: 'Carica dati',
  bProject: 'Progetto',
  projOpen: 'Apri progetto',
  projSave: 'Salva progetto',
  hideTable: 'Nascondi tabella',
  showTable: 'Mostra tabella',
  export: 'Esporta',
  copyValues: 'Copia valori',
  copied: 'Copiato ✓',
  csv: 'Esporta CSV',
  png: 'Esporta PNG',
  pvFile: 'File',
  pvModel: 'Modello',
  pvSupports: 'Vincoli',
  pvEnvelope: 'Inviluppo · max/min per componente',
  pvNote: 'la combinazione governante non è riportata in questo export',
  pvExported: 'esportato',
  secQuantity: 'Grandezza',
  extMax: 'Max',
  extMin: 'Min',
  signHint: 'Compressione positiva. Min < 0 è sollevamento.',
  secCapacity: 'Capacità',
  allowLabel: 'Reazione ammissibile, kN. Vale per la grandezza selezionata.',
  overLabel: 'vincoli oltre l’ammissibile',
  cPair: 'Coppia max / min',
  cUniform: 'Solo colore',
  fit: 'Adatta',
  legClose: 'Nascondi legenda',
  legendChip: 'Legenda',
  secLabels: 'Etichette mappa',
  lblVal: 'Valori',
  lblIds: 'Numeri nodo',
  secGroups: 'Gruppi',
  colorByGroup: 'Colora per gruppo',
  groupCreate: 'Crea gruppo',
  groupDescPh: 'descrizione — es. palo Ø400 L=12m',
  csvGroup: 'Gruppo',
  csvGroupDesc: 'Descrizione',
  groupHint: 'Shift + trascina sulla mappa per selezionare, poi crea un gruppo. Nascondi un gruppo per vedere solo gli altri.',
  groupOnly: 'solo',
  groupDelete: 'elimina',
  groupNew: 'Gruppo',
  ungrouped: 'senza gruppo',
  lblNoteAll: 'Il resto compare al passaggio del mouse — a questa densità mostrarle tutte è illeggibile.',
  lblNoteHidden: '{n} delle prime 10 nascoste — vincoli troppo vicini. Passa il mouse o leggi in tabella.',
  planLabel: 'Pianta',
  mapHint: 'Clic su un vincolo per ispezionarlo · Ctrl-clic per aggiungere alla selezione',
  clearSel: 'Deseleziona',
  distFilter: 'Distribuzione e filtro',
  qAll: 'Tutti',
  qOver: 'Oltre ammissibile',
  qTop: 'Top 5%',
  qUplift: 'Sollevamento',
  histHint: 'Clic su una barra per isolare quella fascia — mappa e tabella seguono lo stesso filtro.',
  clearFilters: 'Azzera filtri',
  legReset: 'Ripristina scala',
  colNode: 'Nodo',
  colUtil: 'Sfrutt.',
  inspector: 'Ispettore',
  noSelection: 'Nessuna selezione',
  supportsSelected: '{n} vincoli selezionati',
  showingFiltered: 'sul set filtrato',
  inspFoot: 'Valori in kN / kNm, compressione positiva. Copia incolla un blocco separato da tabulazioni.',
  scMean: 'media',
  scMax: 'max',
  scMin: 'min',
  scOver: 'oltre amm.',
  scSupports: 'vincoli',
  filteredSet: 'Set filtrato',
  selection: 'Selezione',
  passFilter: '{n} di {m} vincoli passano il filtro',
  toLoaded: 'Caricati {n} vincoli',
  toNoTable: 'Nessuna tabella RFEM riconosciuta',
  toNoNodes: 'Manca la tabella Nodi: senza coordinate non si disegna la pianta',
  toNeedFiles: 'Servono i file JSON o XLSX esportati da RFEM',
  toProjBad: 'File di progetto non valido',
  toProjSaved: 'Progetto salvato',
  dropMsg: 'Rilascia qui i file RFEM (JSON o XLSX)',
  emptyTitle: 'Carica i dati RFEM',
  emptyMsg:
    'Trascina qui la tabella <b>Nodi</b> (coordinate) e la tabella <b>Reazioni vincolari</b>, JSON o XLSX. I dati restano nel tuo browser.',
};

const en: Dict = {
  brandSub: 'Support reactions',
  bLoad: 'Load data',
  bProject: 'Project',
  projOpen: 'Open project',
  projSave: 'Save project',
  hideTable: 'Hide table',
  showTable: 'Show table',
  export: 'Export',
  copyValues: 'Copy values',
  copied: 'Copied ✓',
  csv: 'Export CSV',
  png: 'Export PNG',
  pvFile: 'File',
  pvModel: 'Model',
  pvSupports: 'Supports',
  pvEnvelope: 'Envelope · max/min per component',
  pvNote: 'governing combination not carried in this export',
  pvExported: 'exported',
  secQuantity: 'Quantity',
  extMax: 'Max',
  extMin: 'Min',
  signHint: 'Compression positive. Min < 0 is uplift.',
  secCapacity: 'Capacity',
  allowLabel: 'Allowable, kN. Applies to the selected quantity.',
  overLabel: 'supports over allowable',
  cPair: 'Max / min pair',
  cUniform: 'Colour only',
  fit: 'Fit',
  legClose: 'Hide legend',
  legendChip: 'Legend',
  secLabels: 'Map labels',
  lblVal: 'Values',
  lblIds: 'Node numbers',
  secGroups: 'Groups',
  colorByGroup: 'Colour by group',
  groupCreate: 'Create group',
  groupDescPh: 'description — e.g. pile Ø400 L=12m',
  csvGroup: 'Group',
  csvGroupDesc: 'Description',
  groupHint: 'Shift + drag on the map to select, then create a group. Hide a group to see only the others.',
  groupOnly: 'only',
  groupDelete: 'delete',
  groupNew: 'Group',
  ungrouped: 'ungrouped',
  lblNoteAll: 'Everything else labels on hover — at this density, all-on is unreadable.',
  lblNoteHidden: '{n} of the top 10 labels hidden — supports too close. Hover, or read them off the table.',
  planLabel: 'Plan',
  mapHint: 'Click a support to inspect · Ctrl-click to add to selection',
  clearSel: 'Clear selection',
  distFilter: 'Distribution & filter',
  qAll: 'All',
  qOver: 'Over allowable',
  qTop: 'Top 5%',
  qUplift: 'Uplift',
  histHint: 'Click a bar to isolate that band — map and table follow the same filter.',
  clearFilters: 'Clear filters',
  legReset: 'Reset scale',
  colNode: 'Node',
  colUtil: 'Util',
  inspector: 'Inspector',
  noSelection: 'No selection',
  supportsSelected: '{n} supports selected',
  showingFiltered: 'showing the filtered set',
  inspFoot: 'Values in kN / kNm, compression positive. Copy pastes a tab-separated block.',
  scMean: 'mean',
  scMax: 'max',
  scMin: 'min',
  scOver: 'over',
  scSupports: 'supports',
  filteredSet: 'Filtered set',
  selection: 'Selection',
  passFilter: '{n} of {m} supports pass the filter',
  toLoaded: 'Loaded {n} supports',
  toNoTable: 'No recognizable RFEM table',
  toNoNodes: 'Missing the Nodes table: without coordinates the plan cannot be drawn',
  toNeedFiles: 'Need the JSON or XLSX files exported from RFEM',
  toProjBad: 'Invalid project file',
  toProjSaved: 'Project saved',
  dropMsg: 'Drop the RFEM files here (JSON or XLSX)',
  emptyTitle: 'Load RFEM data',
  emptyMsg:
    'Drop the <b>Nodes</b> table (coordinates) and the <b>Support reactions</b> table here, JSON or XLSX. Data stays in your browser.',
};

const DICTS: Record<Lang, Dict> = { it, en };

export function t(key: string, vars?: Record<string, string | number>): string {
  let s = DICTS[state.lang][key] ?? en[key] ?? key;
  if (vars) for (const k in vars) s = s.replace(`{${k}}`, String(vars[k]));
  return s;
}
